// extracted by mini-css-extract-plugin
export var row = "_uj-0";